import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/recruiter/landing-page/Banner.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/recruiter/landing-page/FrequentQuiz.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/recruiter/landing-page/HiringProcess.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/recruiter/landing-page/KeyFeatures.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/recruiter/landing-page/RequestDemo.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/landing-page.scss");
